import type { RegistryEntry } from "../types.ts";

// The survey registry. Add a line here when you add a survey module.
export const SURVEYS: readonly RegistryEntry[] = [
  {
    slug: "husker-2026",
    title: "2026 Husker Season Survey",
    blurb: "Twelve games, a pile of hot takes, and a leaderboard in December.",
    status: "open",
  },
];
